<template>
  <div class="card questions">
    <div class="card-header">
      <h3 class="card-title">{{ $t('page.title.new_author') }}</h3>
      <div class="float-right">
        <router-link :to="{'name':'authors-list'}">
          <b-button size="sm" variant="outline-primary">{{ $t('btn.back') }}</b-button>
        </router-link>
      </div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-3">
          <b-card>
            <b-card-body>
              <label>{{ $t('page.first_name') }}</label>
              <p>
                <input v-model="formAuthorData.firstName">
              </p>
              <label>{{ $t('page.last_name') }}</label>
              <p>
                <input v-model="formAuthorData.lastName">
              </p>
              <label>{{ $t('page.status') }}</label>
              <p>
                <vue-select
                    v-model="formAuthorData.status"
                    :options="statuses" :reduce="status => status.value"
                    label="text"
                ></vue-select>
              </p>
              <label>{{ $t('page.description') }}</label>
              <p>
                <textarea v-model="formAuthorData.description" rows="8" cols="38"></textarea>
              </p>
              <label>{{ $t('page.welcoming_movie') }}</label>
              <p>
                <input v-model="formAuthorData.welcomingMovieId">
              </p>
              <label>{{ $t('page.avatar') }}</label>
              <p>
                <b-form-file
                    ref="file-input"
                    accept="image/*"
                    @change="uploadFile($event)"
                ></b-form-file>
                <span v-if="avatarPath">
                  <img :src="avatarPath" class="img-thumbnail"/>
                  <b-button type="button" @click="deleteAvatar" variant="danger" class="mr-1">{{ $t('actions.delete') }}</b-button>
                </span>
              </p>
            </b-card-body>
            <div class="buttons float-right">
              <b-button type="button" @click="addAuthor()" variant="success" class="mr-1">{{ $t('actions.save') }}</b-button>
            </div>
          </b-card>
        </div>
        <div class="col-6">

        </div>

      </div>
    </div>
  </div>
</template>

<script>

import alertify from 'alertifyjs';
import axios from "axios";
import { VueSelect } from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  props: ['apiKey'],
  components: {
    VueSelect
  },
  data() {
    return {
      statuses: [
        {value: 'active', text: 'Active'},
        {value: 'inactive', text: 'Inactive'},
        {value: 'bonus', text: 'Bonus'},
        {value: 'deleted', text: 'Deleted'},
      ],
      formAuthorData: {},
    };
  },
  computed: {
    avatarPath: function () {
      return this.$store.getters["authorsStore/avatarPath"];
    },
  },
  mounted() {
    this.deleteAvatar();
  },
  methods: {
    uploadFile(event) {
      let formData = new FormData();

      formData.append("file", event.target.files[0]);

      axios.post("/file/image/upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        },
      })
          .then((response) => {
            this.formAuthorData.avatar = response.data.file;
            this.$store.dispatch('authorsStore/changeAvatarPath', response.data.path)
      })
      .catch(error => {
        console.log(error);
      });
    },
    deleteAvatar() {
      this.formAuthorData.avatar = null;
      this.$refs['file-input'].reset();
      this.$store.dispatch('authorsStore/changeAvatarPath', null);
    },
    addAuthor() {
      const url = '/author';
      axios.post(url, this.formAuthorData)
          .then(() => {
            alertify.success('Dodano nowego autora');
            this.$store.dispatch('authorsStore/changeAvatarPath', null);
            this.$router.push('authors');
          })
          .catch(error => {
            alertify.error(error.response.data.label);
          });
    },
  },
  watch: {
    $route() {
    }
  }
}
</script>

